<template>
    <div class="lineReport">
        <div class="myChart" :id="lineDatas.id" style="width:100%;height:300px"></div>
    </div>
</template>

<script>
import echarts from 'echarts'
export default {
    name: 'lineReport',
    props: ['lineDatas'],
    data() {
        return {
            myChart: null
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.drawLine()
        })
    },
    methods: {
        drawLine() {
            this.myChart = echarts.init(document.getElementById(this.lineDatas.id))
            let [seriesList, colorList, legendList] = [[], [], []]
            let legendAddr = this.lineDatas.legendAddr ? this.lineDatas.legendAddr : 'center'
            let legendFormatter = this.lineDatas.formatter ? this.lineDatas.formatter : '{a} <br/>{b} : {c}'
            for (let i = 0; i < this.lineDatas.data.length; i++) {
                colorList.push(this.lineDatas.data[i].color)
                legendList.push(this.lineDatas.data[i].title)
                seriesList.push({
                    symbolSize: 2, // 设定实心点的大小
                    smooth: this.lineDatas.data[i].smooth ? this.lineDatas.data[i].smooth : false,
                    symbol: this.lineDatas.data[i].symbol ? this.lineDatas.data[i].symbol : 'none', // 设定为实心点 none circle
                    name: this.lineDatas.data[i].title,
                    type: 'line',
                    data: this.lineDatas.data[i].list,
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                width: 2, // 折线宽度
                                color: this.lineDatas.data[i].color // 折线颜色
                            }
                        }
                    }
                })
            }
            var option = {
                color: colorList,
                title: {
                    text: this.lineDatas.title,
                    subtext: this.lineDatas.subText,
                    left: 'left',
                    textStyle: {
                        fontSize: 16
                    }
                },
                tooltip: {
                    // trigger: 'item',
                    trigger: 'axis',
                    formatter: legendFormatter,
                },
                legend: {
                    left: legendAddr,
                    data: legendList
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#ccc'
                        }
                    },
                    data: this.lineDatas.xdata
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        nameTextStyle: {
                            color: '#333'
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#ccc'
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: ['#f2f2f2']
                            }
                        }
                    }
                ],
                series: seriesList
            }

            // 使用刚指定的配置项和数据显示图表。
            this.myChart.setOption(option)
            let myChart = this.myChart
            window.onresize = function () {
                myChart.resize()
            }
        }
    },
    watch: {
        lineDatas: {
            handler: function() {
                this.drawLine()
                this.myChart.resize()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.myChart{
}
</style>
